import React, { useEffect, useState } from "react";
import { AppleIcon, ChevronLeft, ChevronRight } from "lucide-react";

import { getFarmById }  from "../api/farm-service/farmService";

import AnimalsCategory  from "../components/farm/AnimalsCategoryList";
import PYOCategory      from "../components/farm/PYOCategoryList";
import WineryCategory   from "../components/farm/WineryCategoryList";
import TrendingList     from "../components/farm/TrendingList";
import StaffPickList    from "../components/farm/StaffPickList";
import Categories       from "../components/farm/Categories";
import BannerSlider     from "../components/BannerSlider";
import WPPostsPage from "./blog/blog-categories/WPPostsPage";

import useUserLocation  from "../hooks/useUserLocation";

import sponsorBanner    from "../assets/img/Sponsor-banner.jpg";
import test             from "../assets/img/test.jpg";
import AppStyle         from "../assets/stylesheets/App.module.css";

import Logger           from "../utils/logger";

const ANIMALS_CATEGORY_ID = 2; // Example category ID for animals
// const log = Logger.create('HomePage');

// temp data for blogs

const slides = [
  {
    image: test,
    title: (
      <>
        Discover Farms
        <br />
        Create Memories
      </>
    ),
    description:
      "FarmCiti connects you with local farms, fresh products, and stories that grow",
    // buttonText: "View Farms",
    // link: "/"
  },
  {
    image: sponsorBanner,
    title: (
      <>
        Showcase Your Farm<br />
        Join Our Community
      </>
    ),
    description:
      "Looking to feature your farm? Let’s connect!",
    buttonText: "Contact us",
    link: "mailto:farmertoronto@gmail.com"
  }
];

const HomePage = () => {
  /* Check user location example */
  const { location, error } = useUserLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  
  // Add scroll event listener to track scroll position
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 1);
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Check initial scroll position
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={AppStyle["home-page"]}>
      <main className={`${AppStyle["home-main-content"]} ${isScrolled ? AppStyle["home-main-content-scrolled"] : ""}`}>
        <section
          className={`${AppStyle["section"]} ${AppStyle["card-section"]} ${AppStyle["mobile-category"]}`}
        >
          <div className={AppStyle["container"]}>
            <Categories />
          </div>
        </section>

        {/*
          -------------- Header Banner --------------
        */}
        <section
          className={`${AppStyle["section"]} ${AppStyle["banner-section"]}`}
        >
          <BannerSlider slides={slides} />
          <div className={AppStyle["container"]}></div>
        </section>
        {/*
          ------------------------------------------
        */}

        {/* List Trending Farms */}
        <section
          className={`${AppStyle["section"]} ${AppStyle["card-section"]}`}
        >
          <div className={AppStyle["container"]}>
            <TrendingList />
          </div>
        </section>

        <div className={AppStyle["category-strip"]}>
          <section
            className={`${AppStyle["section"]} ${AppStyle["desktop-category"]}`}
          >
            <div className={AppStyle["container"]}>
              <Categories />
            </div>
          </section>
        </div>
        
        {/* List Animal Farms */}
        <section
          className={`${AppStyle["section"]} ${AppStyle["card-section"]}`}
        >
          <div className={AppStyle["container"]}>
            <AnimalsCategory categoryId={ANIMALS_CATEGORY_ID} />
          </div>
        </section>

        {/*
          -------------- middle Banner --------------
        */}
        <section
          className={`${AppStyle["section"]} ${AppStyle["banner-section"]}`}
        >
          <div className={AppStyle["middle-banner"]}>
            <a href="mailto:farmertoronto@gmail.com">
              <img
                src="/assets-temp/img/banner-middle.jpg"
                alt="middle-banner"
              />
            </a>
          </div>
          <div className={AppStyle["container"]}></div>
        </section>
        {/*
          ------------------------------------------
        */}

        {/* List PYO Farms */}
        <section
          className={`${AppStyle["section"]} ${AppStyle["card-section"]}`}
        >
          <div className={AppStyle["container"]}>
            <PYOCategory />
          </div>
        </section>

        {/* List Winery Farms */}
        <section
          className={`${AppStyle["section"]} ${AppStyle["card-section"]}`}
        >
          <div className={AppStyle["container"]}>
            <WineryCategory />
          </div>
        </section>

        {/* List Staff Pick Farms */}
        <section
          className={`${AppStyle["section"]} ${AppStyle["card-section"]}`}
        >
          <div className={AppStyle["container"]}>
            <StaffPickList />
          </div>
        </section>
        
        {/* -------------- bottom Banner -------------- */}

        {/* <section
          className={`${AppStyle["banner-section"]} ${AppStyle["full-section"]}`}
        >

          <div className={AppStyle["bottom-banner"]}>
            <img src="/assets-temp/img/banner-bottom.jpg" alt="bottom-banner" />
          </div>

          <div className={AppStyle["container"]}></div>
        </section> */}
  
        {/* ------------------------------------------ */}

        {/* blog section */}
        <section className={`${AppStyle["section"]} ${AppStyle["card-section"]}`}>
          <WPPostsPage />
        </section>
        {/* end of blog section */}
      </main>
    </div>
  );
};

export default HomePage;
